/**虚拟仿真模块 */
import request from '../request/http';
function queryId(){
    return sessionStorage.getItem('institutionTenantId')||'';
}
/**分页查询虚拟仿真软件 */
export function VirtualSoftwarePageList(data){
    return request({
        url: '/sp/virtualEmulation/virtualSoftwarePageList',
        method: 'post',
        data,
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**分页查询虚仿实训详情记录 */
export function PageQuerySoftwareDrillDetail(data){
    return request({
        url: '/sp/virtualEmulation/pageQuerySoftwareDrillDetail',
        method: 'post',
        data,
    })
}
/**分页查询虚仿实训步骤详情记录 */
export function PageQuerySoftwareModulesDrillDetailList(data){
    return request({
        url: '/sp/virtualEmulation/pageQuerySoftwareModulesDrillDetailList',
        method: 'post',
        data,
    })
}
/**开始实训 */
export function StartDrill(data){
    return request({
        url: '/sp/virtualEmulation/startDrill',
        method: 'post',
        data,
    })
}
/**分页查询虚仿实训步骤详情记录 */
export function QuerySoftwareDrillList(data){
    return request({
        url: '/sp/virtualEmulation/pageQuerySoftwareDrillList',
        method: 'post',
        data,
    })
}
